import { APP_URL } from '@/lib/app-url';

export type AuthFlowIntent = 'createService' | 'apply';

type BuildAuthFlowRedirectUrlArgs = {
  appUrl?: string;
  intent: AuthFlowIntent;
  transferToken: string;
};

const AUTH_FLOW_SENSITIVE_PARAMS = ['transfer', 'serviceData', 'applicationData'] as const;

export const buildAuthFlowRedirectUrl = ({ appUrl = APP_URL, intent, transferToken }: BuildAuthFlowRedirectUrlArgs): string => {
  const url = new URL('/auth/sign-up', appUrl);
  url.searchParams.set('intent', intent);
  url.searchParams.set('transfer', transferToken);
  return url.toString();
};

export const stripAuthFlowSearchParams = (urlString: string): string => {
  const url = new URL(urlString);

  for (const param of AUTH_FLOW_SENSITIVE_PARAMS) {
    url.searchParams.delete(param);
  }

  return url.toString();
};
